// Strips HTML tags and decodes common entities, returning trimmed plain text.
// Use this to extract visible content from RichTextEditor values before validation.
export const stripHtmlText = (html) =>
  (html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .trim();

// messages
const validationMessage = {
  required: "This field is required*",
  email: "Please enter a valid Email ID",
  phoneNo: "Please enter a valid Contact Number",
  uniqueCode: "Please enter a valid 4 character Unique Code",
  pinCode: "Please enter a valid Pincode",
  numberText: "Please enter a valid number & Whitespaces are not allowed.",
  abhyasiIdPattern: "Please enter a valid Abhyasi ID",
  panNoPattern: "Please enter a valid PAN Number",
  aadharPattern: "Please enter a valid Aadhar No",
  name: "Whitespaces are not allowed at the start & Special characters are not allowed.",
  whitespace: "Whitespaces/Special Char are not allowed at the start",
  alphabet: "Only alphabets are allowed",
  freeText: "Required Fields/ Invalid input",
  decimal: "Please enter a valid number & Whitespaces are not allowed",
  notAllowWhitespace: "Leading or trailing whitespace is not allowed.",
  richTextEdgeWhitespace: "Leading or trailing whitespace is not allowed.",
  url: "Provide Valid URL",
  slugUrl: "Special characters not allowed except hyphen(-)",
  pnr: "Please enter a valid PNR",
  websiteName:
    "Please enter a valid website name. Only small case letters (a-z) and underscore (_) between letters is allowed.",
  batchName: "Batch name allows only alphanumeric and space.",
};

// validations
const validations = {
  required: {
    value: true,
    message: validationMessage.required,
  },

  name: {
    value:
      /^[^ <>'\\"/;^`~_=+|?!@#$%^&*()[\]{}][^<>'\\"/;^`~_=+|?!@#$%^&*()[\]{}]*$/,
    message: validationMessage.name,
  },
  pnr: {
    value: /^[A-Z]{2}-[A-Z0-9]{4}-[A-Z]{4}$/,
    message: validationMessage.pnr,
  },

  alphabet: {
    value:
      /^[^ <>'\\"/;^`~_=+|?!@#$%^&*()[\]{}0-9][^<>'\\"/;^`~_=+|?!@#$%^&*()[\]{}0-9]*$/,
    message: validationMessage.alphabet,
  },
  uniqueCode: {
    value: /^[^-\s][0-9A-Z]{3}$/,
    message: validationMessage.uniqueCode,
  },
  email: {
    value: /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
    message: validationMessage.email,
  },

  phoneNo: {
    value: /^[0-9]{10,14}$/,
    message: validationMessage.phoneNo,
  },

  pinCode: {
    value: /^[A-Za-z0-9](?:[-\s]?[A-Za-z0-9]){2,11}$/,
    message: validationMessage.pinCode,
  },

  numberText: {
    value: /^[0-9]*$/,
    message: validationMessage.numberText,
  },

  abhyasiId: {
    value: /^([a-zA-Z]{6}[0-9]{3}|[HABhab]{1}[0-9]{8})$/,
    message: validationMessage.abhyasiIdPattern,
  },

  panNo: {
    value: /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/,
    message: validationMessage.panNoPattern,
  },

  aadhar: {
    value: /^[0-9]{12}$/,
    message: validationMessage.aadharPattern,
  },
  whiteSpace: {
    value: /^[^ >'\\"/;^`~_=+|?!@#$%^&*()[\]{}][^`~]*$/,
    message: validationMessage.whitespace,
  },
  freeText: {
    value: /^[^ ][^`~]*$/,
    message: validationMessage.freeText,
  },
  decimal: {
    value: /^(?![^0-9])[0-9]*(\.[0-9]+)?$/,
    message: validationMessage.decimal,
  },
  url: {
    value:
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
    message: validationMessage.url,
  },
  slugUrl: {
    value: /^[a-zA-Z0-9-]+$/,
    message: validationMessage.slugUrl,
  },
  notAllowWhitespace: {
    value: /^[^\s]+$/,
    message: validationMessage.notAllowWhitespace,
  },
  websiteName: {
    value: /^[a-z][a-z-_]*[a-z]$/,
    message: validationMessage.websiteName,
  },
  batchName: {
    value: /^[A-Za-z0-9]+(?:[ ]+[A-Za-z0-9]+)*$/,
    message: validationMessage.batchName,
  },
  // Use as `validate: validations.richTextRequired` on RichTextEditor fields.
  // Strips HTML tags so whitespace-only or empty editor content is rejected.
  richTextRequired: (value) => {
    const text = stripHtmlText(value);
    return text.length > 0 || validationMessage.required;
  },
  // Use as part of a named validate object on RichTextEditor fields.
  // Rejects content whose visible text starts or ends with whitespace.
  richTextNoEdgeWhitespace: (value) => {
    const raw = (value || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'");
    if (!raw.trim()) return true; // let richTextRequired handle empty
    return raw === raw.trim() || validationMessage.richTextEdgeWhitespace;
  },
};

export default validations;
